export default "__VITE_ASSET__CRp9wayf__"